module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Basic Crosstab")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b64f4a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/partials/examples/BasicCrosstab.vue
// module id = 63
// module chunks = 0